import React, {Component} from 'react';
import {MODE_SOLUTION, TYPE_THEMATIQUE} from './constants';
import MediaQuery from 'react-responsive';
import {BeatLoader} from 'react-spinners';
import RemoteContainer from "./components/remote/RemoteContainer";
import ScreenContainer from "./components/screen/ScreenContainer";
import SplashScreenContainer from "./components/screen/SplashScreenContainer";
import PauseScreenContainer from "./components/screen/PauseScreenContainer";
import TabsContainer from "./components/tabs/TabsContainer";
import SolutionContainer from "./components/solution/SolutionContainer";
import screenfull from "screenfull";
import './App.scss';

class App extends Component {

  render() {

    const {mode, type, showSplashScreen, showPauseScreen} = this.props;

    if (this.props.loading) {
      return (
        <div className="loader-container">
          <BeatLoader size={30}/>
        </div>
      );
    }

    if (screenfull.isEnabled) {
      if (this.props.fullscreen && !screenfull.isFullscreen) {
        screenfull.request();
        screenfull.on('change', () => {
          if ((this.props.fullscreen && !screenfull.isFullscreen) || (!this.props.fullscreen && screenfull.isFullscreen)) {
            this.props.onToggleFullscreen();
          }
        });
      } else if (!this.props.fullscreen && screenfull.isFullscreen) {
        screenfull.exit();
      }
    }

    let appContent;
    if (mode === MODE_SOLUTION) {
      appContent = (
        <SolutionContainer/>
      );
    } else {
      /*
      const remote = type !== TYPE_THEMATIQUE ? (
        <MediaQuery minDeviceWidth={769}>
          <RemoteContainer/>
        </MediaQuery>
      ) : null;
      */
      appContent = (
        <React.Fragment>
          {showSplashScreen ? <SplashScreenContainer/> : null}
          {showPauseScreen ? <PauseScreenContainer/> : null}
          <TabsContainer/>
          <div className="app-main-container">
            <div className="app-body-container">
              <div className="app-body-screen-container">
                <ScreenContainer/>
                {/*remote*/}
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }

    return (
      <div className={'app-container ' + (this.props.fullscreen ? 'fullscreen' : '')}>
        {appContent}
      </div>
    );
  }
}

export default App;
